import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'ctep-core-content',
    imports: [CommonModule, RouterModule],
    templateUrl: './ctep-content.component.html',
    styleUrl: './ctep-content.component.scss'
})
export class CtepContentComponent {}
